export const MeasurementUnitDetails  = new Map<string, string>([
    ['mile', 'Miles'],
    ['kilometer', 'Kilometers']
]);
